"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _DatePickerTabs = require("./DatePickerTabs");

var _default = _DatePickerTabs.DatePickerTabs;
exports["default"] = _default;